import React from 'react';
import FinancialForm from '../components/Shared/FinancialForm';
import FinancialTable from '../components/Shared/FinancialTable';

const Receivables = ({ items, onAddItem, onUpdateStatus, loading }) => {
  return (
    <div>
      <h2>Contas a Receber</h2>
      <FinancialForm 
        onAddItem={onAddItem} 
        type="receivable" 
      />
      {loading ? <p>Carregando...</p> : (
        <FinancialTable 
          items={items} 
          onUpdateStatus={onUpdateStatus} 
          type="receivable" 
        />
      )}
    </div>
  );
};

export default Receivables;